const KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || '';

/** Local CRA: setupProxy. Production: Netlify redirects /api/* → functions. */
function apiBase() {
  if (process.env.REACT_APP_PAYMENT_API) return process.env.REACT_APP_PAYMENT_API.replace(/\/$/, '');
  return '/api';
}

function loadRazorpayScript() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }
    const existing = document.querySelector('script[data-razorpay]');
    if (existing) {
      existing.addEventListener('load', () => resolve(window.Razorpay));
      existing.addEventListener('error', () => reject(new Error('Failed to load Razorpay')));
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.dataset.razorpay = 'true';
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error('Failed to load Razorpay'));
    document.body.appendChild(script);
  });
}

async function postJson(path, body) {
  const res = await fetch(`${apiBase()}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

/**
 * Create a Razorpay order for cart items and open Checkout.
 * @returns {Promise<{ ok: boolean, paymentId?: string, orderId?: string, amount?: number, cancelled?: boolean }>}
 * `amount` is the server-computed charge in paise.
 */
export async function payWithRazorpay({ items, customer }) {
  if (!KEY_ID) {
    throw new Error('Razorpay key is missing. Set REACT_APP_RAZORPAY_KEY_ID in .env');
  }

  const order = await postJson('/create-order', {
    items: items.map((i) => ({ id: i.id, qty: i.qty, size: i.size || 50 })),
    customer,
  });

  const Razorpay = await loadRazorpayScript();

  return new Promise((resolve, reject) => {
    const rzp = new Razorpay({
      key: order.keyId || KEY_ID,
      amount: order.amount,
      currency: order.currency || 'INR',
      name: 'Rajpurohit Perfumes',
      description: 'Fragrance order',
      order_id: order.orderId,
      prefill: {
        name: customer?.name || '',
        email: customer?.email || '',
        contact: customer?.contact || '',
      },
      notes: {
        source: 'web',
      },
      theme: {
        color: '#1A2332',
      },
      handler: async (response) => {
        try {
          const verified = await postJson('/verify-payment', response);
          resolve({
            ok: true,
            paymentId: verified.paymentId || response.razorpay_payment_id,
            orderId: verified.orderId || response.razorpay_order_id,
            amount: order.amount,
          });
        } catch (err) {
          reject(err);
        }
      },
      modal: {
        ondismiss: () => resolve({ ok: false, cancelled: true }),
      },
    });

    rzp.on('payment.failed', (resp) => {
      reject(new Error(resp?.error?.description || 'Payment failed'));
    });

    rzp.open();
  });
}
